import PropTypes from "prop-types"
import React, { useLayoutEffect, useRef, useState } from "react"

import Button from "src/components/Button"

const TextCollapsible = ({
  children,
  lines = 3,
  showMoreText = "show more",
  showLessText = "show less",
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)
  const contentRef = useRef(null)

  useLayoutEffect(() => {
    // Only check truncation when collapsed, otherwise we lose the state
    if (isExpanded) return

    const checkTruncation = () => {
      if (contentRef.current) {
        setIsTruncated(
          contentRef.current.scrollHeight > contentRef.current.clientHeight
        )
      }
    }
    checkTruncation()
  }, [children, lines, isExpanded])

  return (
    <div className={className}>
      <div
        ref={contentRef}
        className={!isExpanded ? `line-clamp-${lines}` : undefined}
      >
        {children}
      </div>
      {isTruncated && (
        <Button variant="link" small onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? showLessText : showMoreText}
        </Button>
      )}
    </div>
  )
}

TextCollapsible.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
  className: PropTypes.string,
}

export default TextCollapsible
